import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", { style: {"margin":"16px -16px"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", { style: {"margin":"16px -16px"} }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", { style: {"margin":"16px -16px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_DetailClientParent = _resolveComponent("DetailClientParent")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Tax = _resolveComponent("Tax")!
  const _component_PaymentInfo = _resolveComponent("PaymentInfo")!
  const _component_ContactInfo = _resolveComponent("ContactInfo")!
  const _component_BillingInfo = _resolveComponent("BillingInfo")!
  const _component_Agreement = _resolveComponent("Agreement")!
  const _component_BankInfo = _resolveComponent("BankInfo")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetail,
    onBack: _ctx.goBack,
    title: _ctx.getTitle(),
    "vertical-separator": false,
    fullPage: ""
  }, {
    "top-right": _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_button_fill, {
          isDisabled: !_ctx.isFormValidParent,
          onClick: _ctx.showPopupRegistParent,
          title: _ctx.$t('clientManagement.infoPriceClient.save'),
          class: "bg-red-lp-300 px-8"
        }, null, 8, ["isDisabled", "onClick", "title"])
      ])
    ]),
    data: _withCtx(() => [
      _createVNode(_component_Card, {
        rounded: "xl",
        customClass: "border border-gray-lp-400 p-4 mb-6",
        isShadow: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DetailClientParent, {
            "model-value": _ctx.form.clientParent,
            "onUpdate:modelValue": _ctx.mergeClientParentData,
            error: _ctx.error.clientParent,
            "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_ctx.error.clientParent = $event)),
            isMY: _ctx.isMYDistrict,
            managingCountryOptions: _ctx.managingCountryOptions,
            onChangeDistrict: _ctx.onChangeDistrict
          }, null, 8, ["model-value", "onUpdate:modelValue", "error", "isMY", "managingCountryOptions", "onChangeDistrict"])
        ]),
        _: 1
      }),
      _createVNode(_component_Card, {
        rounded: "xl",
        customClass: "border border-gray-lp-400 p-4 mb-6",
        isShadow: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Tax, {
            modelValue: _ctx.form.tax,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.tax = $event)),
            error: _ctx.error.tax,
            "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (_ctx.error.tax = $event)),
            isMY: _ctx.isMYDistrict,
            isManagingCountryMY: _ctx.isManagingCountryMalaysia,
            taxValidationConfig: _ctx.taxValidationConfig
          }, null, 8, ["modelValue", "error", "isMY", "isManagingCountryMY", "taxValidationConfig"]),
          _hoisted_2,
          _createVNode(_component_PaymentInfo, {
            modelValue: _ctx.form.payment,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.payment = $event)),
            isMY: _ctx.isMYDistrict
          }, null, 8, ["modelValue", "isMY"]),
          _hoisted_3,
          _createVNode(_component_ContactInfo, {
            modelValue: _ctx.form.contact,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.contact = $event)),
            error: _ctx.error.contact,
            "onUpdate:error": _cache[6] || (_cache[6] = ($event: any) => (_ctx.error.contact = $event)),
            isMY: _ctx.isMYDistrict
          }, null, 8, ["modelValue", "error", "isMY"]),
          _hoisted_4,
          _createVNode(_component_BillingInfo, {
            modelValue: _ctx.form.billing,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.billing = $event)),
            error: _ctx.error.billing,
            "onUpdate:error": _cache[8] || (_cache[8] = ($event: any) => (_ctx.error.billing = $event)),
            isMY: _ctx.isMYDistrict
          }, null, 8, ["modelValue", "error", "isMY"])
        ]),
        _: 1
      }),
      _createVNode(_component_Card, {
        rounded: "xl",
        customClass: "border border-gray-lp-400 p-4 mb-6",
        isShadow: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Agreement, {
            modelValue: _ctx.form.agreement,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.agreement = $event)),
            error: _ctx.error.agreement,
            "onUpdate:error": _cache[10] || (_cache[10] = ($event: any) => (_ctx.error.agreement = $event))
          }, null, 8, ["modelValue", "error"])
        ]),
        _: 1
      }),
      _createVNode(_component_Card, {
        rounded: "xl",
        customClass: "border border-gray-lp-400 p-4 mb-6",
        isShadow: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BankInfo)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading", "error", "errorType", "onTryAgain", "onBack", "title"]))
}